export default {"src":"/_next/static/media/AEM.7a24bba6.svg","height":18,"width":18};